import {Component, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {ToastService} from '../../services/toast.service';

@Component({
  selector: 'app-authenticate',
  imports: [

  ],
  template: `
    <div class="hero min-h-screen bg-base-200">
      <div class="hero-content flex-col w-full max-w-sm">

        <!-- Logo -->
        <img
          src="logo.png"
          alt="Prezzemolo & Vitale"
          class="w-64 mb-2"
        />

        <!-- Login Card -->
        <div class="card bg-base-100 w-full shadow-2xl">
          <div class="card-body">
            <h2 class="text-2xl font-light tracking-widest text-center text-base-content/70 uppercase mb-4">Accesso in corso...</h2>
            
            @if (error() === 401 || error() === 400) {
              <div class="alert alert-error mb-3" role="status" aria-live="polite">
                Non è stato possibile accedere
              </div>
            } @else if (error()) {
              <div class="alert alert-error mb-3" role="status" aria-live="polite">
                Si è verificato un problema durante l'accesso
              </div>
            } @else {
              <div class="alert alert-info mb-3" role="status" aria-live="polite">
                Attendi qualche secondo
              </div>
            }
          </div>
        </div>

      </div>
    </div>
  `,
  styles: ``
})
export class AuthenticateComponent implements OnInit {
  private router = inject(Router);
  private auth = inject(AuthService);
  private route = inject(ActivatedRoute);
  public error = signal<number|null>(null);
  public toast = inject(ToastService);

  public redirectUrl = 'home/qr-scan';

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      const identifier = params.get('data');
      if (identifier) {
        this.auth.login(identifier).subscribe({next: (response) => {
          localStorage.setItem('token', response.data.user.jwt ?? '');
          localStorage.setItem('user', JSON.stringify(response.data.user));
          localStorage.setItem('factorial_identifier', response.data.factorial_identifier);
          this.router.navigate([this.redirectUrl]);
        }, error: (error) => {
          this.error.set(error.status);
        }});
      } else {
        this.error.set(400);
      }
    });
  }

}
